<h1 mat-dialog-title>
  {{ injectData.dialogTitle }}
</h1>
<form #form="ngForm" [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
  <div mat-dialog-content>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.name' | translate }}</mat-label>
        <input matInput [formControl]="addEditForm.controls.name" />
        <mat-error [control]="addEditForm.controls.name"></mat-error>
      </mat-form-field>

      <div class="col-12">
        <mat-dropdown
          [configurationInput]="dataSourceDropdownSettings"
          [options]="store.dataSources()"
          [formControl]="addEditForm.controls.dataSourceId"
          [isLoading]="store.areDataSourcesLoading()"
          [isFormSubmitted]="form.submitted"
        >
        </mat-dropdown>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.endpoint' | translate }}</mat-label>
        <input matInput [formControl]="addEditForm.controls.endpoint" />
        <mat-error [control]="addEditForm.controls.endpoint"></mat-error>
      </mat-form-field>

      <div class="col-12">
        <mat-dropdown
          [configurationInput]="resultTypeDropdownSettings"
          [options]="resultTypeDropdownOptions"
          [formControl]="addEditForm.controls.resultType"
          [isFormSubmitted]="form.submitted"
        >
        </mat-dropdown>
      </div>

      @if (addEditForm.controls.resultType.value.length) {
        @if (addEditForm.controls.resultType.value[0].id === EResultType.singleField) {
          <mat-form-field appearance="outline" class="mb-4">
            <mat-label>{{ 'field.responseTemplate' | translate }}</mat-label>
            <input matInput [formControl]="addEditForm.controls.content" />
            <mat-hint>{{ 'page.dataIntegrations.contentFieldHint' | translate }}</mat-hint>
            <mat-error [control]="addEditForm.controls.content"></mat-error>
          </mat-form-field>
        } @else {
          <mat-form-field appearance="outline" class="mb-4" subscriptSizing="dynamic">
            <mat-label>{{ 'field.contentPath' | translate }}</mat-label>
            <input matInput [formControl]="addEditForm.controls.content" />
            <mat-error [control]="addEditForm.controls.content"></mat-error>
          </mat-form-field>
        }
      }

      <div class="col-12">
        <mat-dropdown
          [configurationInput]="requestMethodDropdownSettings"
          [options]="requestMethodDropdownOptions"
          [formControl]="addEditForm.controls.requestMethod"
          [isFormSubmitted]="form.submitted"
        >
        </mat-dropdown>
      </div>

      <div class="mb-3">
        <span class="dialog-section"
          ><mat-icon class="material-icons-outlined">groups</mat-icon>
          {{ 'system.dialogSection.accessAndPermissions' | translate }}</span
        >
      </div>

      <div class="col-12">
        <mat-dropdown
          [configurationInput]="restrictAccessByDropdownSettings"
          [options]="restrictAccessByDropdownOptions"
          [formControl]="addEditForm.controls.restrictAccessBy"
          [isFormSubmitted]="form.submitted"
        >
        </mat-dropdown>
      </div>

      @if (addEditForm.controls.restrictAccessBy.value.length) {
        @switch (addEditForm.controls.restrictAccessBy.value[0].id) {
          @case (ERestrictAccessBy.dashboard) {
            <div class="col-12">
              <mat-dropdown
                [configurationInput]="dashboardDropdownSettings"
                [options]="store.dashboards()"
                [formControl]="addEditForm.controls.dashboardId"
                [isLoading]="store.areDashboardsLoading()"
                [isFormSubmitted]="form.submitted"
                (search)="dashboardSearch.next($event)"
              >
              </mat-dropdown>
            </div>
          }

          @case (ERestrictAccessBy.workspace) {
            <div class="col-12">
              <mat-dropdown
                [configurationInput]="workspaceDropdownSettings"
                [options]="store.workspaces()"
                [formControl]="addEditForm.controls.workspaceId"
                [isLoading]="store.areWorkspacesLoading()"
                [isFormSubmitted]="form.submitted"
                (search)="workspaceSearch.next($event)"
              >
              </mat-dropdown>
            </div>
          }
        }
      }
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    <button mat-flat-button type="submit">
      {{ injectData.submitButtonText }}
    </button>
  </mat-dialog-actions>
</form>
